import React from 'react';
import Img from 'gatsby-image';
import { useStaticQuery, graphql } from 'gatsby';
import { ImageWrapper, InnerImageWrapper } from '../elements';
import { SideBarWrapper } from '../elements/Sidebar';

export const Image = ({ fixed, extension, publicURL }) => {
  const data = useStaticQuery(graphql`
    query {
      imageSharp(fixed: { originalName: { eq: "chip.jpg" } }) {
        fixed {
          ...GatsbyImageSharpFixed
        }
      }
    }
  `);

  const imageStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  };

  return (
    <ImageWrapper>
      <SideBarWrapper />
      <InnerImageWrapper>
        {!fixed && extension === 'svg' ? (
          <img
            style={{
              height: '100%',
              minWidth: '100%',
            }}
            src={publicURL}
            alt='Image not found'
          />
        ) : (
          <Img
            fixed={fixed ? fixed : data.imageSharp.fixed}
            style={imageStyle}
          />
        )}
      </InnerImageWrapper>
      <SideBarWrapper />
    </ImageWrapper>
  );
};
